export default "__VITE_ASSET__BhFvtE5Y__"